import { integrateLbxTasks } from '../utils/lineOrders';
import { TrainStatus } from '../utils/train';
import { StatusValue } from '../utils/statusValue';
import { validation, validationFail, validationOk } from '../utils/helpers';

export class TrainEntity {}

/// 车次状态 "待排车" 状态
const StatusToArrange = StatusValue.create(TrainStatus.TO_ARRANGE);
TrainEntity.statusIsToArrange = function (train) {
    return StatusToArrange.is(+train.dispatchStatus);
};

/// 计算运单数量: : 菜鸟大件，计算同一客户订单号下的运单数之和
TrainEntity.computeOrderNum = function (train) {
    return (train.tasks || []).reduce((acc, t) => acc + ((t.children && t.children.length) || 1), 0);
};

/// 计算运单体积: 菜鸟大件，计算同一客户订单号下的体积之和
TrainEntity.computeVolume = function (train) {
    return (train.tasks || []).reduce((acc, task) => {
        if (task.children && task.children.length) {
            return acc + task.children.reduce((_acc, _task) => _acc + _task.totalVolume, 0);
        } else {
            return acc + task.totalVolume;
        }
    }, 0);
};

TrainEntity.toAdjustPreCheck = function (trains) {
    const trainsToArrange = trains
        .filter((r) => {
            const dispatchStatus = StatusValue.create(+r.dispatchStatus);
            // 只有 "待排车" 状态 的车次才可进行调整
            return dispatchStatus.is(TrainStatus.TO_ARRANGE);
        });

    if (trains.length !== trainsToArrange.length) {
        return validationFail('只有状态为待排车的车次可以进行调整');
    }

    // 要检查是否是同一个排车单号
    const lineCodeSet = new Set(trains.map(t => t.lineCode));
    if (lineCodeSet.size !== 1) {
        return validationFail('只有同一排单下的车次才可以进行车次间调整');
    }

    return validationOk;
};

TrainEntity.adjustPreConfirm = function (trains) {
    const volumeOverflowTrains = []; // { trainNum, totalVolume, truckMaxVolume }
    for (const train of trains) {
        const totalVolume = TrainEntity.computeVolume(train);
        if (totalVolume > train.truckMaxVolume) {
            volumeOverflowTrains.push({ trainNum: train.trainNum, totalVolume, truckMaxVolume: train.truckMaxVolume });
        }
    }
    if (volumeOverflowTrains.length > 0) {
        const messages = volumeOverflowTrains.map((t) => `车次[${t.trainNum}]方量超限，推荐车型最大载荷方量[${t.truckMaxVolume}]，当前方量[${t.totalVolume}]`);
        return validationFail(`<p style="line-height: 1.3">${messages.join('<br/><br/>')}<br/><br/>是否确认调整？</p>`);
    }
    return validationOk;
};

TrainEntity.invalidatePreCheck = function (trains) {
    return validation(
        !trains.some(r => StatusValue.create(+r.dispatchStatus).isNot(TrainStatus.TO_ARRANGE)),
        '选中的数据存在非“待排车”状态，请重新选择！'
    );
};

/// 标准化车次(运单数据), 便于前端逻辑处理
TrainEntity.normalize = function (sef) {
    const lineOrders = sef.lineOrderResponseList || [];

    // 整合 非LBX运单 和 LBX完整运单列表, 并验证
    const integratedTasks = integrateLbxTasks(lineOrders, lineOrders);

    // 使用 tasks 来保存 lineOrderList
    sef.tasks = integratedTasks;

    return sef;
};
